<template>
  <div id="loadding" class="loadding-page">
        <div class="loadding-loader"></div>
    </div>
</template>

<script>
export default {

}
</script>
<style lang="scss" scoped>

/* Center the loader */
.loadding-loader {
    @include positions(absolute, 50%, unset, unset, 50%);
    @include size(50px, 50px);
    z-index: 1;
    margin: -25px 0 0 -25px;
    border: 6px solid #2c2e3d;
    border-radius: 50%;
    border-top: 6px solid #ffffff;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* Add animation to "page content" */

.animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
}

@-webkit-keyframes animatebottom {
    from {
        bottom: -100px;
        opacity: 0
    }

    to {
        bottom: 0px;
        opacity: 1
    }
}

@keyframes animatebottom {
    from {
        bottom: -100px;
        opacity: 0
    }

    to {
        bottom: 0;
        opacity: 1
    }
}

.loadding-page {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
    background-color: rgba(44, 46, 61, .6);
}
</style>